// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__8LLJU","checked":"Checkbox_checked__BzC30","disabled":"Checkbox_disabled__L3IyY"};